// Shared Shopify previews resolve languages from a simple locale path.
// Their localization POST can return to / and lose the selected language.
function cherriesSubmitLocalization(form, input, selection) {
  if (!input || !form) return;
  input.value = selection;
  if (
    /\.shopifypreview\.com$/i.test(window.location.hostname) &&
    ['locale_code', 'language_code'].includes(input.name) &&
    /^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(selection)
  ) {
    const destination = new URL(window.location.href);
    const parts = destination.pathname.split('/').filter(Boolean);
    const currentLocale = document.documentElement.lang.toLowerCase();
    if (parts[0]?.toLowerCase() === currentLocale) parts.shift();
    const languagePrefix = selection.toLowerCase() === 'en' ? '' : '/' + selection.toLowerCase();
    destination.pathname = languagePrefix + (parts.length ? '/' + parts.join('/') : '/');
    window.location.assign(destination.href);
    return;
  }
  HTMLFormElement.prototype.submit.call(form);
}

if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.openSelector.bind(this));

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
        }
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer').classList.remove('country-selector-open');
        this.header.preventHide = false;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        // The delegated fallback may already have handled this same click.
        if (event.defaultPrevented) return;
        event.preventDefault();
        cherriesSubmitLocalization(this.querySelector('form'), this.elements.input, event.currentTarget.dataset.value);
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }
        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }
        if (this.hasAttribute('data-prevent-hide')) {
          this.header.preventHide = true;
        }
        document.querySelector('.menu-drawer').classList.add('country-selector-open');
      }

      closeSelector(event) {
        if (
          event.target.classList.contains('country-selector__overlay') ||
          !this.contains(event.target) ||
          !this.contains(event.relatedTarget)
        ) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}

// CHERRIES: localization fallback and English Klaviyo headline
(() => {
  if (window.__cherriesLocalizationFixLoaded) return;
  window.__cherriesLocalizationFixLoaded = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('localization-form button.localization-form__select');

    if (button) {
      const form = button.closest('localization-form');
      const panel = form && form.querySelector('.disclosure__list-wrapper');
      const expandedBefore = button.getAttribute('aria-expanded');

      window.setTimeout(() => {
        if (!panel || button.getAttribute('aria-expanded') !== expandedBefore) return;

        const shouldOpen = expandedBefore !== 'true';
        button.setAttribute('aria-expanded', shouldOpen.toString());
        panel.toggleAttribute('hidden', !shouldOpen);
      }, 0);

      return;
    }

    const option = event.target.closest('localization-form a[data-value]');
    if (!option || event.defaultPrevented) return;

    const localizationForm = option.closest('localization-form');
    const input = localizationForm && localizationForm.querySelector(
      'input[name="locale_code"], input[name="country_code"]'
    );
    const form = localizationForm && localizationForm.querySelector('form');

    if (!input || !form) return;

    event.preventDefault();
    cherriesSubmitLocalization(form, input, option.dataset.value);
  }, true);

  const translateKlaviyoHeadline = () => {
    if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;

    document.querySelectorAll('[class*="kl-private-reset-css"] span').forEach((element) => {
      if (element.textContent.trim().toUpperCase() === 'KRIJG 15% KORTING!') {
        element.textContent = 'GET 15% OFF!';
      }
    });
  };

  translateKlaviyoHeadline();

  new MutationObserver(translateKlaviyoHeadline).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
